var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_5283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0249 3C7.40684 3 6.80265 3.18328 6.28875 3.52666C5.77484 3.87004 5.3743 4.3581 5.13778 4.92911C4.90126 5.50013 4.83937 6.12847 4.95995 6.73466C5.08053 7.34085 5.37816 7.89767 5.8152 8.33471C6.25223 8.77175 6.80906 9.06938 7.41525 9.18995C8.02144 9.31053 8.64977 9.24865 9.22079 9.01212C9.79181 8.7756 10.2799 8.37506 10.6232 7.86116C10.9666 7.34725 11.1499 6.74307 11.1499 6.125C11.1499 5.2962 10.8207 4.50134 10.2346 3.91529C9.64856 3.32924 8.85371 3 8.0249 3Z",
    fill: "white",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9976 5.87901 15.1539 3.84558 13.6542 2.34582C12.1544 0.846052 10.121 0.00241984 8 0ZM12.5669 13.1006C12.5555 12.351 12.2501 11.636 11.7165 11.1095C11.183 10.583 10.4639 10.2871 9.71429 10.2857H6.28572C5.53611 10.2871 4.81705 10.583 4.28348 11.1095C3.74991 11.636 3.44453 12.351 3.43315 13.1006C2.3969 12.1753 1.66613 10.9571 1.33762 9.60723C1.00911 8.2574 1.09835 6.83962 1.59351 5.54163C2.08868 4.24364 2.96641 3.12667 4.1105 2.33861C5.25459 1.55055 6.61105 1.12859 8.00029 1.12859C9.38952 1.12859 10.746 1.55055 11.8901 2.33861C13.0342 3.12667 13.9119 4.24364 14.4071 5.54163C14.9022 6.83962 14.9915 8.2574 14.663 9.60723C14.3344 10.9571 13.6037 12.1753 12.5674 13.1006H12.5669Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_5283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAvatar);
export default __webpack_public_path__ + "static/media/CardAvatar.b06e8fbd30724b93a8133ab93464fe36.svg";
export { ForwardRef as ReactComponent };